import { params } from '../index.js';
let last_high, last_low, last_ttime, last_uvol, last_refp, last_gap, last_close, last_vol, last_period;  //上筆資料
let twn_tdate, twn_vol;

/*****************************************
 當日資料, 格式((open=111;high=xxx;))
 夜盤: 分鐘=tdate, 日周月=cdate
******/
export function twnTick ( datas, period )
{
    let candleres = [];
    let volumeres = [];
    let lineres = [];
    let res = {};
    let LineData= {};
    let this_refp, updn;
    let max_fi = 0;
    if( datas == null ){
        return {'candle':{},'line':{},'volume':{},'fi':2};
    }    
    datas.forEach((value) => {        
        let fi = helpers._decimalNum(parseFloat(value['last']));
        if( max_fi < fi ) max_fi=fi;
        let utime;
        let td = value.tdate;
        let tt;
        if( params['exc'] == 12 && period>=2 ) td = value.cdate;
        if( period == 1 ){
            if( params['exc'] ==12 ){
                tt = value.ttime;
                utime = format_utime(td,tt,period,1);
            }else{
                tt = value.ttime;
                utime = format_utime(td,tt,period,1);
            }
        }else{
            tt='000000';
            utime = format_utime(td,tt,period,1);
            if( period == 3 ) td = helpers._get_week_time(utime);
            else if( period == 4 ) td = helpers._get_month_time(utime);
            utime = format_utime(td,tt,period,1);
            
            if( period == 3 || period == 4 ){
                twn_tdate = td;
                twn_vol = value['vol'];
            }
        }        
        //----------------------------------------
        updn=(!last_close)?0:parseFloat((value['last']-last_close).toFixed(2));
        if( updn > 0 ){
            color = "EA0000";
        }else if( updn < 0 ){
            color = "01B468";
        }else{
            color = "#FFFFFF";
        }
        LineData = {
            time: utime,
            open: parseFloat(value['open']),
            high: parseFloat(value['high']),
            low:  parseFloat(value['low']),
            close: parseFloat(value['last']),
            uvol: (period==1)?parseFloat(value['uvol']):parseFloat(value['vol']),
            vol: parseFloat(value['vol']),
            updn: updn,
            ltime: value.ltime,
        };
        if( LineData['open'] == LineData['close'] ){
            LineData['color'] = "#FFFFFF";
            LineData['wickColor'] = "#FFFFFF";
            LineData['borderColor'] = "#FFFFFF";
        }
        candleres.push(LineData);
        //----------------------------------------
        let color = "#AAAAAA";
        this_refp = value['last'];
        if( !last_refp ) last_refp = this_refp;
        let isRise = this_refp - last_refp;
        if( isRise > 0 ){
            color = "#ef5350";
        }else if( isRise < 0 ){
            color = '#26a69a';
        }
        LineData = {
            time: utime,
            //value: parseFloat(value['uvol']),
            value: (period==1)?parseFloat(value['uvol']):parseFloat(value['vol']),
            color: color,
            ltime: value.ltime,
        };
        volumeres.push(LineData);
        //----------------------------------------
        LineData = {
            time: utime,
            value: parseFloat(value['last']),
            ltime: value.ltime,
            xtime: [td,"T",tt,"Z"].join(""),            
        };
        lineres.push(LineData);
        //----------------------------------------        
        last_refp = this_refp;        
        last_close = value['last'];
        last_ttime= utime;

    });
    let series = {'candle':candleres,'line':lineres,'volume':volumeres,'fi':max_fi};
    return series;
}
/*****************************************
 歷史資料處理, 格式:
 ['20240729', '942.00', '948.00', '936.00', '944.00', '42377', '150000']
 ['20240730', '942.00', '948.00', '936.00', '944.00', '42377', '150000']
******/

export function hisData ( datas, period, exc )
{
    let candleres = [];
    let volumeres = [];
    let lineres = [];
    let res = {};
    let LineData= {};
    let this_refp, color, updn;
    let max_fi = 0;
    datas.forEach((value) => {
        let fi = helpers._decimalNum(parseFloat(value[4]));
        if( max_fi < fi ) max_fi=fi;
        
        let utime,td,tt;
        if( period >=2 ){
            td = value[0];
            tt = '000000';
            utime = format_utime(td,tt,period,1);
        }else{
            td  = value[0];
            if( exc==12 ) td  = value[7];
            tt  = value[6];
            utime = format_utime(td,tt,period,1);
        }
        let last_key = null;
        if( last_ttime == utime ){
            //console.log( td,tt, lineres.length -1 );
            last_key = lineres.length -1;
        }
        //----------------------------------------
        updn=(!last_close)?0:parseFloat((value[4]-last_close).toFixed(2));
        if( last_key ){
            volumeres[last_key]['open'] = parseFloat(value[1]);
            volumeres[last_key]['high'] = parseFloat(value[2]);
            volumeres[last_key]['low'] = parseFloat(value[3]);
            volumeres[last_key]['close'] = parseFloat(value[4]);
            volumeres[last_key]['uvol'] = parseFloat(value[5]);
            volumeres[last_key]['updn'] = updn;
            if( volumeres[last_key]['open'] == volumeres[last_key]['close'] ){            
                volumeres[last_key]['color'] = "#FFFFFF";      // 平盤蠟燭的顏色
                volumeres[last_key]['wickColor'] = "#FFFFFF";  // 平盤影線的顏色
                volumeres[last_key]['borderColor'] = "#FFFFFF";// 平盤邊框顏色
            }


        }else{        
            LineData = {
                time: utime,
                open: parseFloat(value[1]),
                high: parseFloat(value[2]),
                low:  parseFloat(value[3]),
                close: parseFloat(value[4]),
                uvol: parseFloat(value[5]),
                updn: updn,
                xtime: [td,tt].join(""),
            };
            if( LineData['open'] == LineData['close'] ){            
                LineData['color'] = "#FFFFFF";      // 平盤蠟燭的顏色
                LineData['wickColor'] = "#FFFFFF";  // 平盤影線的顏色
                LineData['borderColor'] = "#FFFFFF";// 平盤邊框顏色
            }
            candleres.push(LineData);

        }        
        //----------------------------------------
        let color = "#AAAAAA";
        this_refp = value[4];
        if( !last_refp ) last_refp = this_refp;
        let isRise = this_refp - last_refp;
        if( isRise > 0 ){
            color = "#ef5350";
        }else if( isRise < 0 ){
            color = '#26a69a';
        }
        if( last_key ){
            volumeres[last_key]['value'] = parseFloat(value[5]);
        }else{        
            LineData = {
                time: utime,
                value: parseFloat(value[5]),
                color: color,
            };
            volumeres.push(LineData);
        }
        //----------------------------------------
        if( last_key ){
            lineres[last_key]['value'] = parseFloat(value[4]);
        }else{
            LineData = {
                time: utime,
                value: parseFloat(value[4]),
                xtime: [td,"T",tt,"Z"].join(""),
            };
            lineres.push(LineData);
        }
        //----------------------------------------        
        last_refp = this_refp;        
        last_close = value[4];
        last_ttime= utime;      
    });
    let series = {'candle':candleres,'line':lineres,'volume':volumeres,'fi':max_fi};
    return series;
}


/*******************
  處理ws收到的數據
  data 為一筆資料 ((field=value;))
*******/
var map_trq = {0:0
	,501:'bid1',502:'bid2',503:'bid3',504:'bid4',505:'bid5'
	,506:'bidv1',507:'bidv2',508:'bidv3',509:'bidv4',510:'bidv5'
	,511:'ask1',512:'ask2',513:'ask3',514:'ask4',515:'ask5'
	,516:'askv1',517:'askv2',518:'askv3',519:'askv4',520:'askv5'
	,551:'sbid',552:'sbidv',553:'sask',554:'saskv'	//虛擬
	,555:'sbid2',556:'sbidv2',557:'sask2',558:'askv2'
	,559:'sbid3',560:'sbidv3',561:'sask3',562:'askv3'
	,0:'uvol',1:'open',2:'high',3:'low',4:'last',5:'prev',6:'vol',7:'pv',8:'btl',9:'atl'
	,10:'bid',11:'ask',12:'bidv',13:'askv',14:'oi',15:'btv',16:'atv',17:'maxp',18:'minp',19:'ph'
	,20:'pl',21:'po',22:'asset',23:'tbidl',24:'taskl',25:'termh',26:'terml',27:'warn',28:'stlp',29:'ttp'
	,30:'sv',31:'tbidv',32:'taskv',33:'tgrp',34:'ldate',35:'prctp',36:'rno',37:'cdate',38:'setm',39:'pstlp'  //35:'prctp'
	,40:'tvol',41:'lottm',42:'lotbi',43:'lotak',44:'lotla',45:'lotvo',46:'avgprc',47:'snoflag',48:'setm2',49:'unit'
	,50:'exctxn',51:'tlt',52:'srtm',53:'prevoi',54:'esv',55:'tsts',56:'exttm6',57:'flgrp',58:'ptlv'
    ,58:'mk,'
	,'tm6':'ttime'
};
let keep = {};   //儲存最新一筆資料
/******************************
 處理每筆由WebSocket收到的簡易資料
*******************************/
function ShowLineMap(sda){
    var da = {};
    var fk = '';
    Object.keys(sda).forEach(function(field) {
        let value = sda[field];
        if( map_trq[field] == undefined ){ 
            da[field] = value;			
        }else{
            if( field == 'tm6' ){
                da[field] = value;
            }
            fk = map_trq[field];
            da[fk] = value;
        }
    });
    return da;
}
function wsSeriesData(da,period,gap,opts)
{    
    //if( !da['ttime'] || ) return;
    let skey = da['exc'] + ":" + da['sno'];
    if( !da['tdate'] ) da['tdate'] = keep[skey]['tdate'];
    let td = da['tdate'];
    let tt = da['ttime'];
    let utime;
    let uvol;
    let updn;
    const this_refp = da['last'];
    let isRise;

    if( params['exc'] == 12 && period>=2 ) td = opts['init']['cdate'];
    if( period == 1 ){
        tt = helpers._combttime(da['ttime'],gap)[1];  
    }else{
        tt='000000';
        utime = format_utime(td,tt,period,1);
        if( period == 3 ) td = helpers._get_week_time(utime);
        else if( period == 4 ) td = helpers._get_month_time(utime);
    }
    utime = format_utime(td,tt,period,1);    
    da['uvol'] = parseFloat(da['uvol']);
    if( !last_gap || last_gap != gap ){  last_ttime = null; last_gap = gap; }
    if( !last_refp ) last_refp = this_refp;

    if( period == 1 )
    {    
        //isRise = this_refp - last_refp;
        if( !last_ttime || last_ttime != utime ){
            last_ttime= utime;
            last_high = da['last'];
            last_low  = da['last'];
            if( !da['open'] ) da['open']=da['last'];
        }else{
            if( last_high < da['last'] ) last_high = da['last'];
            if( last_low > da['last'] ) last_low = da['last'];
        }        
        updn = 0; //由上層判斷
        uvol = da['uvol'];
        //last_close = da['last'];

    }else if( period == 2 ){
        //if( !last_high ) last_high = keep[skey]['high'];
        //if( last_high < da['last'] ) last_high = da['last'];
        //if( !last_low ) last_low = keep[skey]['low'];
        //if( last_low > da['last'] ) last_low = da['last'];
        last_high = da['last'];  //上層function會判斷
        last_low  = da['last'];
        //isRise = this_refp - last_refp;
        updn = (!keep[skey]['prev'])?0:parseFloat(da['last']-keep[skey]['prev'],2);
        uvol = (da['vol'])?parseFloat(da['vol']):parseFloat(keep[skey]['vol']);  //日=總量,週+=總量,月+=總量        
    }else{
        last_high = da['last'];
        last_low  = da['last'];
        uvol = (da['vol'])?parseFloat(da['vol']):parseFloat(keep[skey]['vol']);  //日=總量,週+=總量,月+=總量
        updn = (!last_close)?0:parseFloat(da['last']-last_close,2);
    }    
    const lineres = {
        time: utime,
        value: (da['last'])?parseFloat(da['last']):parseFloat(keep[skey]['last']),
        ltime: da['ttime'],
        xtime: [td,"T",tt,"Z"].join(""),            
    };
    const candleres = {
        time: utime,
        open: parseFloat(da['open']),
        high: (da['high'])?parseFloat(da['high']):parseFloat(last_high),
        low:  (da['low'])?parseFloat(da['low']):parseFloat(last_low),
        close:(da['last'])?parseFloat(da['last']):parseFloat(keep[skey]['last']),
        uvol: parseFloat(uvol),
        updn: updn,
        xtime: [td,"T",tt,"Z"].join(""),
        ltime: da['ttime'],
    };        
    //----------------------------------------
    let color = "#AAAAAA";    
    if( isRise > 0 ){
        color = "#ef5350";
    }else if( isRise < 0 ){
        color = '#26a69a';
    }
    const volumeres = {
        time: utime,
        value: parseFloat(uvol),
        color: color,
        xtime: [td,"T",tt,"Z"].join(""),
        ltime: da['ttime'],
    };
    return {'candle':candleres,'line':lineres,'volume':volumeres}
}
function format_utime(td,tt,period,type=0){   
    let utime;
    //格式一: UNIX 時間戳
    if( type == 1 ){
        let yy = td.substring(0,4);
        let mm = td.substring(4,6)-1;
        let dd = td.substring(6,8);
        let hh = tt.toString().substring(0,2);
        let ii = tt.toString().substring(2,4);
        let ss = tt.toString().substring(4,6);
        let utcDate;
        if( period==1 ){
            utcDate = new Date(Date.UTC(yy, mm, dd, hh, ii, 0));
        }else{
            utcDate = new Date(Date.UTC(yy, mm, dd, 0,0,0));
        }
        utime = utcDate.getTime()/1000;
    }else{
        let yy = td.substring(0,4);
        let mm = td.substring(4,6).padStart(2,'0');
        let dd = td.substring(6,8).padStart(2,'0');
        let hh = tt.substring(0,2).padStart(2,'0');
        let ii = tt.substring(2,4).padStart(2,'0');
        let ss = tt.substring(4,6).padStart(2,'0');
        if( period == 1 ){
            utime = [yy,mm,dd].join("-") + "T" + [hh,ii,"00"].join(":") + "Z";
        }else{
            utime = [yy,mm,dd].join("-");
        }
    }    
    return utime;
}
/****
 
*****/
function unix2tdate(utime){
//console.log("unix2tdate",utime);
    let date = new Date(utime * 1000);
    let year = date.getUTCFullYear().toString().substr(2,4);
    let month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    let day = date.getUTCDate().toString().padStart(2, '0');
    let hh = date.getUTCHours().toString().padStart(2, '0');
    let mm = date.getUTCMinutes().toString().padStart(2, '0');
    let words,dateStr;
    words = [month, day];
    dateStr = words.join("/");
    words = [hh,mm];
    dateStr = dateStr + " " + words.join(":");
    return dateStr;
}
function clear_last_value(){
    last_high=null;
    last_low=null;
    last_ttime=null;
    last_uvol=null;
    last_refp=null;
    last_gap=null;
    last_close=null;
    last_vol=null;
    last_period=null;
}
/****************************************************
  last_twntick 從twntick查回的最後一筆資料

//areaSeries.update({ time: '2018-12-31', value: 25 });
//chart_list.update({ time: '2019-01-01', open: 109.87, high: 114.69, low: 85.66, close: 112 });    
******/

export function wsData(data,period,gap,opts,last_twntick) {
    if( data.match(/type\=conn\.hbt/) ){ return; }
    if( !data ) return;
    if( last_period && last_period != period ) clear_last_value();
    let content = data.match(/\(\((.+?)\)\)/)?.[1] ?? "default value if no match";
    let arr = content.split(";");    
    let da = {};
    let field;
    let value;

    arr.forEach((val) => {
        if( val == '' ){ return ; }
        field = val.split(/=/)[0];
        value = val.split(/=/)[1];
        //if( field != 'tdate' && field != 'ttime' && field != 'last' ) return;
        //if( value == -999999 ){ value = ' '; }
        if( value == -999999 ){ return; }
        da[field] = value;
    });
    if( da['sno'] == undefined ){ return; }

    // 變動欄位傳送
    if( da['t'] == 'r.q' )  
    {
        //if( (typeof user)=="undefined" || user == 'guest' ){
        //    return;
        //}
//console.log('WsData:', data);

        let temp = ShowLineMap(da);
        da = {};
        Object.keys(temp).forEach(function(field) {
            if( field != 'sno' && field != 'exc' && field != 'open' && field != 'high' && field != 'low' && field != 'uvol' && field != 'vol' && field != 'last' && field != 'ttime' && field != 'ttp' ) return;
            da[field] = temp[field];
        });
       if( da['tdate'] == undefined ){
            if( opts['init']['exc']==12 ){
                da['tdate'] = opts['init']['cdate']; //查回的K線資料是以結算日為日期
            }else{
                da['tdate'] = opts['init']['tdate'];
            }
        }        
        if( !da['open'] && !da['high'] && !da['low'] && !da['uvol'] && !da['vol'] && !da['last'] ) return;
        if( helpers._check_data( da, opts ) == false ) return;
        let skey = da['exc'] + ":" + da['sno'];        
        if( da['open'] && da['open'].trim().length==0 ){  //8/28早上判斷沒進來
            keep[skey] = {
                //"tdate":opts['init']['tdate'],
                "tdate":da['tdate'],
                "prev":da['prev'], 
                "maxp":da['maxp'], 
                "minp":da['minp'],
                "fi":da['fi'],
                "sexc":da['sexc'],
                "uvol": 0,
                "vol": 0,
            };
        }else{ 
            if( da['open'] && da['open'].trim().length>0 ) keep[skey]['open'] = da['open'];
            if( da['high'] && da['high'].trim().length>0 ) keep[skey]['high'] = da['high'];
            if( da['low']  && da['low'].trim().length>0 )  keep[skey]['low'] = da['low'];
            if( da['last'] && da['last'].trim().length>0) keep[skey]['last'] = da['last'];
            if( da['uvol'] && da['uvol'].trim().length>0) keep[skey]['uvol'] = da['uvol'];
            if( da['vol'] && da['vol'].trim().length>0)  keep[skey]['vol'] = da['vol'];
        }
        if ( Object.keys(da).length > 0 && keep[skey]['vol']>0 ){
            //console.log("Valid information");
            last_period == period;
            const series = wsSeriesData(da,period,gap,opts);
            return series;
        }else{
            return;
        }

    // tick 成交價
    }else if( da['t'] == 'r.t' ){

    // 接收後回覆訊息
    }else if( da['type'] == 'reg.sno' ){

    // 完整欄位傳送
    }else if( da['type'] == 'rtd.sno' )
    {
//console.log('WsData:', data);   
        let skey = da['exc'] + ":" + da['sno'];
        keep[skey] = {
            "tdate":da['tdate'],
            "prev":(da['sexc']==4)?da['refp']:da['prev'], 
            "maxp":da['maxp'], 
            "minp":da['minp'],
            "open":da['open'], 
            "high":da['high'],
            "low":da['low'],
            "fi":da['fi'],
            "sexc":da['sexc'],
            "last":da['last'],
            "uvol":da['uvol'],
            "vol":da['vol'],
        };
        if( helpers._check_data( da, opts ) == false ) return;
        if( da['open'].trim().length==0 || da['last'].trim().length==0 ){
            console.log("盤前");
            return;
        }
        if( last_twntick != undefined ){
            const tt = helpers._combttime(da['ttime'],gap)[1];
            const utime = format_utime(da['tdate'],tt,period,1);            
            if( last_twntick['time'] == utime ){
                const uvol = da['vol'] - last_twntick['vol'];
                da['uvol']=uvol;  //修正時間差
                if( uvol == 0 ) return;
            }
            da['high']=last_twntick['high'];  //保留原時間的高低值
            da['low'] =last_twntick['low'];
        }
        if( last_twntick != undefined )  last_ttime = last_twntick['time'];    
        const series = wsSeriesData(da,period,gap,opts);
        series['fi'] = da['fi'];
        return series;
    }
}
export function generateData() {
    var res = [];
    //var res = '';
    //var time = new Date(Date.UTC(2018, 0, 1, 0, 0, 0, 0));
    var time = new Date();
    //for (var i = 0; i < 10; ++i) {
    //    res.push({
    //        time: time.getTime() / 1000,
    //        value: i,
    //    });
    //    time.setUTCDate(time.getUTCDate() + 1);
    //}
    var i = Math.floor(Math.random() * 50);
    var t = Math.floor(time.getTime() / 1000);
    var mm = time.getMinutes();
    var ss = time.getSeconds();
    var hh = time.getHours();
    let utcDate = new Date(Date.UTC(2024, 7, 29, hh, mm, 0));
    var ttime = hh + ":" + mm;
    let utime = Math.floor(utcDate.getTime() / 1000);
    //res.push({
    //    time: time.getTime() / 1000,
    //    value: i,
    //});
    res = {time:utime,value:i,ttime:ttime};
    //{ time: '2024-08-29T10:02:00', open: 103, high: 108, low: 102, close: 104 }
    return res
}
/////////////////////////////////////////////////////////////////////

var helpers = {
    /*
    * helpers._combttime
    * 時間以gap來合併, 回覆timer
    */
    _combttime : function ( ttime, gap )
    {
        
        let hh = parseInt(ttime / 10000);
        let mm = parseInt((ttime - hh * 10000) / 100);
        let ss = parseInt(ttime - hh * 10000 - mm * 100);
        let rema = mm % gap;
        if( rema == 0 && ss == 0 ){ //秒為00時, 要算在上一分鐘
            if( mm == 0 ){
                mm = 60 - gap;
                hh = hh -1;
            }else{
                mm = mm - gap;
            }
        }else{
            mm = mm - rema;
        }
        let temp_ttime = hh*10000 + mm*100;
        temp_ttime = temp_ttime.toString().padStart(6,'0');
        return [ttime,temp_ttime];
    },
    /*
    * helpers._get_week_time
    * 取得周線日期
    */
    _get_week_time : function( utime )
    {
        const date = new Date(utime * 1000);
        const day = date.getDay();
        const dayOffset = day === 0 ? 6 : day - 1;
        const monday = new Date(date);
        monday.setDate(date.getDate() - dayOffset);
        let yy = monday.getUTCFullYear().toString();
        let mm = (monday.getUTCMonth() + 1).toString().padStart(2, '0');
        let dd = monday.getUTCDate().toString().padStart(2, '0');        
        return [yy,mm,dd].join("");
    },
    /*
    * helpers._get_month_time
    * 取得月線日期
    */
    _get_month_time : function( utime )
    {
        const date = new Date(utime * 1000);
        let yy = date.getUTCFullYear().toString();
        let mm = (date.getUTCMonth() + 1).toString().padStart(2, '0');
        let dd = '01';
        return [yy,mm,dd].join("");
    },
    /*
    * helpers._check_data
    * 判斷交易時間及試撮合
    */
    _check_data : function( da,opts )
    {
        //ttp 內外盤 29 _TTP 成交內外盤 (v&1=0: 外盤), (v&1=1:內盤)(v&4=1: 試撮合)
        if( da['ttp'] && (da['ttp'] == 4 || da['ttp'] == 5 || da[29] == 4 || da[29] == 5) ){
            //console.log("試撮合 ttp="+da['ttp']);                
            return false;
        }
        const etime = eval(opts['base']['etime']);
        const stime = eval(opts['base']['stime']);
        if( etime<stime ){
            if( opts['base']['delstime'] && da['ttime'] >= opts['base']['delstime'] && da['ttime'] <= opts['base']['deletime'] ){
                console.log("wsdatas",da['ttime'], "盤前1");
                return false;
            }else if( da['ttime'] > etime && da['ttime'] < stime ){
                console.log("wsdatas",da['ttime'], "盤後12");
                return false;
            }
        }else if( da['ttime'] > etime || da['ttime'] < stime ){ 
            console.log("wsdatas",da['ttime'], "盤前後");
            return false; 
        }
        return true;
    },
    _decimalNum : function (num) 
    {
        let len;
        if( num.toString().includes('.') ){
            len = num.toString().split(".")[1].length;
        }else{
            len = 0;
        }
        return len;
    }  
}